/* eslint-disable react/no-unknown-property */
import { FC, useEffect, useState } from 'react'
import styles from './pd-standalone-video.module.scss'

export interface StandaloneVideoProps {
  source: string
  show: boolean
  muted?: boolean
  onClosed: () => void
}

const PdStandaloneVideo: FC<StandaloneVideoProps> = ({ source, onClosed, show, muted }) => {
  /* loading video */
  const [loading, setLoading] = useState<boolean>(true)

  function onLoadEnd() {
    setLoading(false)
  }

  return (
    <div
      className={[
        'fixed w-screen h-screen top-0 left-0 bg-black flex justify-center items-center z-[99999] transition-transform duration-700 ease-in-out -translate-y-full',
        show ? '!translate-y-0' : '',
      ].join(' ')}
      onTransitionEnd={() => !show && setLoading(true)}
    >
      <div className="video-wrapper w-full">
        {show && (
          <video
            className={['border-none aspect-video mx-auto', loading ? 'w-0' : 'w-full laptop:w-1/2'].join(' ')}
            autoPlay={true}
            webkit-playsinline="true"
            playsInline
            x-webkit-airplay="true"
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            controls={true}
            controlsList={'nodownload'}
            muted={muted ?? true}
            onLoadedData={() => onLoadEnd()}
            onLoad={() => onLoadEnd()}
          >
            <source src={source} type="video/mp4" />
          </video>
        )}

        {loading && (
          <div className={styles.waveLoading}>
            <div className="wave"></div>
            <div className="wave"></div>
            <div className="wave"></div>
            <div className="wave"></div>
            <div className="wave"></div>
            <div className="wave"></div>
            <div className="wave"></div>
            <div className="wave"></div>
            <div className="wave"></div>
            <div className="wave"></div>
          </div>
        )}
      </div>

      <div
        className={[
          'right-1/2 translate-x-1/2',
          'laptop:right-12 laptop:translate-x-0',
          'close absolute top-12  w-12 h-12 cursor-pointer',
        ].join(' ')}
        onClick={() => onClosed()}
      >
        <img className="w-full h-full" src="/icons/icon_close_white.svg" alt="close icon" />
      </div>
    </div>
  )
}

export default PdStandaloneVideo
